import React, { useEffect } from 'react';
import '../../css/myshopping.css';
import DOMPurify from 'dompurify';

export default function AgreeDetail({ detailText }: any) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return <div className="detailbox" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(detailText) }}></div>;
}
